import React from 'react';
export default function EmptyCell({ text = 'None' }) {
  return <div className="font-weight-300 fs-xs font-italic text-muted">{text}</div>;
}
